<template>
	<div class="content">
		<div class="banner wow animate__animated animate__fadeInUp animate__delay-0.3s">
			<img src="../../static/images/iot/banner.png" v-show="currlangs==0" >
			<img src="../../static/images/iot/eng/1.png" v-show="currlangs==1" >
			<img src="../../static/images/iot/eng/2.png" v-show="currlangs==2" >
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	import { WOW } from 'wowjs'
	import IotIndex from './iotIndex.vue'

	export default {
	  name: 'iotManage',
	  components:{
	    IotIndex
	  },
		data() {
			return {
				showLoading: true,

				currlangs: 0, //0中文 1英文 2西班牙语
				langs: zh,
			}
		},
		mounted() {
			let _this = this;

			_this.currlangs = sessionStorage.getItem('UPUS_langs');
			console.info(_this.currlangs)
			if(_this.currlangs == 2) {
				_this.langs = sp;
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
			} else {
				_this.langs = zh;
			}
		},
		methods: {

		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/iotManage.vue